import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export const AdminProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-sm text-muted-foreground">Cargando…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return children;
};

export default AdminProtectedRoute;
